// Fix node
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
(window as any).global = window;

// Define unknown CSS properties used in Angular animations
['flex', 'flexDirection', 'willChange'].forEach((prop) => {
  // Test if the property can be configured
  try {
    Object.defineProperty(document.body.style, prop, {
      enumerable: true,
      configurable: true,
    });
  } catch {
    // eslint-disable-next-line no-console
    console.error(`Property '${prop}' cannot be configured.`);
  }
});
// Fix IE11
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
if (!Element.prototype.matches) {
  // eslint-disable-next-line
  Element.prototype.matches = (Element.prototype as any).msMatchesSelector;
}
